import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectAirportComponent } from '../select-airport/select-airport.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { InputTextModule } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';
import { TransportFormService } from 'src/app/trip-calculator/services/transport-form.service';
import { ErrorComponent } from '../../../error/error.component';
import { TooltipIconComponent } from 'src/app/shared/tooltip-icon/tooltip-icon.component';

@Component({
  selector: 'app-tim-form',
  imports: [
    SelectAirportComponent,
    TranslocoPipe,
    ReactiveFormsModule,
    InputTextModule,
    DatePickerModule,
    ErrorComponent,
    TooltipIconComponent
  ],
  templateUrl: './tim-form.component.html',
})
export class TIMFormComponent implements OnInit {
  transportFormService = inject(TransportFormService);

  ngOnInit() {
    this.transportFormService.createTimControls();
  }
}
